module.exports = __webpack_public_path__ + "img/wolverhampton-wolves.20375974.png";